import { Component, Input, OnInit } from '@angular/core';
import { Test } from 'src/app/models/test.model';

@Component({
  selector: 'ct-cover-page-report',
  templateUrl: './cover-page-report.component.html',
  styleUrls: ['./cover-page-report.component.scss']
})
export class CoverPageReportComponent implements OnInit {
    @Input() colors: any;
    @Input() reportType: any;
    @Input() test: Test;
    @Input() currentDate: any;
    @Input() isMD: boolean;

  constructor() { }

  ngOnInit(): void {
  }

}
